import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=550e214e&"
import script from "./SubCategories.vue?vue&type=script&lang=js&"
export * from "./SubCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubCategories.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports